<template>
    <MenuBase :hidden="props.hidden"
        tooltip="Stage sync"
        :tooltipPosition="props.tooltipPosition"
        :theme="props.theme"
        :tooltipText="props.tooltipText"
        @click="openStageSync()" >
        <RadioIcon class="size-6" />
    </MenuBase>
</template>
<script setup>
import { defineProps, defineEmits } from 'vue'
import MenuBase from '@/components/common/menus/MenuBase.vue';
import { RadioIcon } from '@heroicons/vue/24/outline';
import { appEvents } from '@/store/app.events';

const emit = defineEmits(['openStageSync'])
const props = defineProps( {
    hidden: {
        type: Boolean,
        default: true
    },
    tooltipPosition: {
        type: String,
        default: 'top',
        validator: (value) => {
            return ['top', 'bottom', 'left', 'right'].includes(value);
        }
    }
})

const openStageSync = () => {
    emit('openStageSync');
    appEvents.emit('open-stage-sync-modal');
}
</script>
